/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/react-in-jsx-scope */
import React, { useMemo } from "react";
import classNames from "classnames";
import { NON_RKPAY_INVOICE_COLUMNS, V3_INVOICE_TYPE_ID, INVOICE_STATUSES } from "@constants";
import PropTypes from "prop-types";
import utils from "@utils";
import { ScrollDetect, Tooltip } from "../../../../components";

const PendingSubmissionTable = ({
	updateSort,
	selectAllRecords,
	multipleSelection,
	filters,
	records,
	onEditInvoice,
	selectedRecords,
	updateSelectedRecord,
	user,
	showMultipleOfficerModal,
	hasMoreRecords,
	loadNextPage,
	onSendInvoices,
	canSendMultipleInvoices,
	clientV4InvoicingDisputesEnabled,
}) => {
	const { lang } = global;

	const selectedList = Object.values(selectedRecords);
	const clientIdSelected = !!filters.clientId;

	const hasSelectedRecords = selectedList.length > 0;

	const selectedVersions = useMemo(
		() => new Set(selectedList.map(invoice => invoice.Version)),
		[selectedList],
	);

	const recordsVersions = useMemo(
		() => new Set(records.map(invoice => invoice.Version)),
		[records],
	);

	const isPendingOfficerSubmissionFilter = !!filters.pendingOfficerSubmission;

	const selectedVersion = selectedVersions.size === 1 ? [...selectedVersions][0] : null;
	const hasMixedInvoiceVersions = recordsVersions.size > 1;

	return (
		<>
			<div
				className="row hidden-xs hidden-sm hidden-md invoice-columns"
				data-test-id="pending-submission-table__header-columns"
			>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber);
					}}
				>
					<If condition={multipleSelection && canSendMultipleInvoices}>
						{clientIdSelected && (
							<label
								htmlFor="checkbox_all"
								className="selector-label margin-right-12"
								onClick={e => e.stopPropagation()}
							>
								<input
									type="checkbox"
									id="checkbox_all"
									name="selectAllItems"
									onChange={() => selectAllRecords()}
									onClick={e => e.stopPropagation()}
									aria-label="Select All Items"
									disabled={!clientIdSelected || hasMixedInvoiceVersions}
									data-test-id="pending-submission-table__header-select-all"
								/>
							</label>
						)}
						{!clientIdSelected && (
							<Tooltip
								content={lang.t("Filter by client to bulk send invoices")}
								placement="right"
							>
								<label
									htmlFor="checkbox_all"
									className="selector-label margin-right-12"
								>
									<input
										type="checkbox"
										id="checkbox_all"
										name="selectAllItems"
										aria-label="Select All Items"
										disabled={!clientIdSelected}
									/>
								</label>
							</Tooltip>
						)}
					</If>
					<span className="font-semi-bold">{lang.t("Invoice")} #</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName);
					}}
				>
					<span className="font-semi-bold">{lang.t("Client")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.ClientName}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2">
					<span className="font-semi-bold">{lang.t("Officer")}</span>
				</div>
				{/** Use StartDateTime as sort field, there is no JobDateRange field in endpoint, we build that with StartDateTime and EndDateTime */}
				<div
					className="col-md-2 col-lg-1 date-range-column"
					role="button"
					tabIndex="0"
				>
					<span className="font-semi-bold">{lang.t("Job Date")}</span>
				</div>
				<div
					className="col-md-2 col-lg-1 date-range-column"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.IssueDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.IssueDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Created Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.IssueDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Total)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Total);
					}}
				>
					<span className="font-semi-bold">{lang.t("Total")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Total}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2 hidden-xs hidden-md" />
			</div>
			<div
				className="hidden-xs hidden-sm hidden-md invoice-columns-body"
				data-test-id="pending-submission-table__body"
			>
				{records.length > 0 &&
					records.map((item, index) => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);

						const isDisputed =
							clientV4InvoicingDisputesEnabled && item.DisputeActionRequired;

						return (
							<div
								key={`${item.Id}-${item.InvoiceNumber}`}
								className="row"
								role="button"
								onClick={onEditInvoice(item.Id)}
								data-test-id={`pending-submission-table__body-row-${index}`}
								tabIndex={0}
							>
								<div className="col-md-2 col-lg-2 flex align-items-start truncate">
									<If condition={multipleSelection && canSendMultipleInvoices}>
										{clientIdSelected && (
											<label
												htmlFor={`check_${item.Id}`}
												className="selector-label margin-right-12"
												onClick={e => e.stopPropagation()}
											>
												<input
													type="checkbox"
													id={`check_${item.Id}`}
													name="selectItem"
													checked={selectedRecords[item.Id]}
													onChange={() => updateSelectedRecord(item)}
													onClick={e => e.stopPropagation()}
													aria-label="Select Item"
													disabled={
														!clientIdSelected ||
														(selectedVersion !== null &&
															item.Version !== selectedVersion)
													}
												/>
											</label>
										)}
										{!clientIdSelected && (
											<Tooltip
												content={lang.t(
													"Filter by client to bulk send invoices",
												)}
												placement="right"
											>
												<label
													htmlFor={`check_${item.Id}`}
													className="selector-label margin-right-12"
												>
													<input
														type="checkbox"
														id={`check_${item.Id}`}
														name="selectItem"
														aria-label="Select Item"
														disabled={!clientIdSelected}
													/>
												</label>
											</Tooltip>
										)}
									</If>
									<span className="flex flex-align-items-center flex-justify-content-space-between flex-1">
										{item.InvoiceNumber}
									</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={item.ClientName}
								>
									<span>{item.ClientName}</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={
										item.OfficerNames.length > 1
											? lang.t("Multiple Officers")
											: item.OfficerNames[0]
									}
								>
									<If condition={item.OfficerNames.length > 1}>
										<button
											id={`multiple-officer-button-${item.Id}`}
											type="button"
											className="btn btn-link btn-officers"
											onClick={event => {
												event?.stopPropagation();
												showMultipleOfficerModal(item.Id);
											}}
										>
											{lang.t("Multiple Officers")}
										</button>
									</If>
									<If condition={item.OfficerNames.length <= 1}>
										<span>{item.OfficerNames[0]}</span>
									</If>
								</div>
								<div className="col-md-2 col-lg-1 date-range-column">
									<span>
										{sameJobDay
											? utils.formatDate(
													item.StartDateTime,
													"en-US",
													user.TimeZoneId,
													"numeric",
												)
											: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
									</span>
								</div>
								<div className="col-md-2 col-lg-1 date-range-column">
									<span>
										{utils.formatDate(
											item.IssueDate,
											"en-US",
											undefined,
											"numeric",
										)}
									</span>
								</div>
								<div
									className={classNames("col-md-2 col-lg-2 text-right flex", {
										"flex-justify-content-space-between":
											item.IsPrepaid || isDisputed,
										"flex-justify-content-end": !item.IsPrepaid && !isDisputed,
									})}
								>
									<div className="flex flex-align-items-center flex-gap-8">
										{item.IsPrepaid && (
											<div className="prepay-badge-container">
												<div
													className="prepay-badge"
													title={lang.t("Prepay")}
												/>
											</div>
										)}
										{isDisputed && (
											<span
												className="label label-danger width-16 height-16 flex flex-align-items-center flex-justify-content-center padding-0"
												title={lang.t("Disputed")}
											>
												{lang.t("!")}
											</span>
										)}
									</div>
									<span className="font-semi-bold flex align-items-center">
										{utils.currencyFormatter(item.GrandTotal)}
									</span>
								</div>
								<If condition={item.TypeId === V3_INVOICE_TYPE_ID.OFFICER &&
										item.StatusId === INVOICE_STATUSES.CREATED &&
										isPendingOfficerSubmissionFilter
									}
								>
									<div className="col-md-12 col-lg-2 actions-column">
											<button
												type="button"
												className="btn btn-primary btn-block grow"
												onClick={() => onEditInvoice(item.Id)}
												data-prevent-navigation
											>
												{lang.t("View")}
											</button>
									</div>
								</If>
								<If
									condition={
										item.TypeId === V3_INVOICE_TYPE_ID.AGENCY ||
										item.StatusId !== INVOICE_STATUSES.CREATED
									}
								>
									<div className="col-md-12 col-lg-2 actions-column">
										{item.Voided ? (
											<button
												type="button"
												className="btn btn-primary btn-block grow"
												onClick={() => onEditInvoice(item.Id)}
												data-prevent-navigation
											>
												{lang.t("View")}
											</button>
										) : (
											<>
											<button
												type="button"
												className="btn btn-primary"
												onClick={() => onEditInvoice(item.Id)}
											>
												<i className="rkf rkf-pencil" aria-label="edit invoice" />
											</button>

											<button
												type="button"
												className="btn btn-primary grow"
												onClick={e => {
													e.stopPropagation();
													onSendInvoices([item.Id]);
												}}
												disabled={
													hasSelectedRecords ||
													user.isSuperAdmin() ||
													isDisputed
												}
												data-test-id={`pending-submission-table__body-row-send-${index}`}
											>
												{lang.t("Send")}
											</button>
											</>
										)}
									</div>

								</If>
							</div>
						);
					})}
			</div>
			<div className="hidden-lg">
				{records.length > 0 &&
					records.map(item => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);
						const isDisputed =
							clientV4InvoicingDisputesEnabled && item.DisputeActionRequired;

						return (
							<div
								key={`${item.Id}-${item.InvoiceNumber}`}
								className="row"
							>
								<div className="invoice-card">
									{isDisputed && (
										<div className="label label-danger">
											{lang.t("Disputed")}
										</div>
									)}
									<div className="card-item">
										<If condition={item.IsPrepaid}>
											<div
												className="prepay-badge"
												title={lang.t("Prepay")}
											/>
										</If>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Invoice")} #:&nbsp;
										</span>
										<button
											className="btn btn-link"
											type="button"
											onClick={onEditInvoice(item.Id)}
										>
											{item.InvoiceNumber}
										</button>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Client")}:&nbsp;
										</span>
										<span>{item.ClientName}</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Officer")}:&nbsp;
										</span>
										<If condition={item.OfficerNames.length > 1}>
											<button
												type="button"
												className="btn btn-link btn-officers"
												onClick={() => showMultipleOfficerModal(item.Id)}
											>
												{lang.t("Multiple Officers")}
											</button>
										</If>
										<If condition={item.OfficerNames.length <= 1}>
											<span>{item.OfficerNames[0]}</span>
										</If>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Job Date")}:&nbsp;
										</span>
										<span>
											{sameJobDay
												? utils.formatDate(
														item.StartDateTime,
														"en-US",
														user.TimeZoneId,
														"numeric",
													)
												: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Created Date")}:&nbsp;
										</span>
										<span>
											{utils.formatDate(
												item.IssueDate,
												"en-US",
												undefined,
												"numeric",
											)}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Total")}:&nbsp;
										</span>
										<span>
											{utils.currencyFormatter(
												utils.bankersRound(item.GrandTotal),
											)}
										</span>
									</div>
									<div className="actions">
										<button
											type="button"
											className="btn btn-primary"
											onClick={onEditInvoice(item.Id)}
										>
											<i
												className="rkf rkf-pencil"
												aria-label="edit invoice"
											/>
										</button>
										<button
											type="button"
											className="btn btn-primary grow"
											disabled={
												hasSelectedRecords ||
												user.isSuperAdmin() ||
												item.Voided ||
												isDisputed
											}
											onClick={e => {
												e.stopPropagation();
												onSendInvoices([item.Id]);
											}}
										>
											{lang.t("Send")}
										</button>
									</div>
								</div>
							</div>
						);
					})}
			</div>
			<If condition={hasMoreRecords}>
				<ScrollDetect
					className="text-center"
					onVisible={() => loadNextPage()}
				>
					<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
				</ScrollDetect>
			</If>
		</>
	);
};

PendingSubmissionTable.propTypes = {
	updateSort: PropTypes.func,
	selectAllRecords: PropTypes.func,
	multipleSelection: PropTypes.bool,
	filters: PropTypes.object,
	records: PropTypes.array,
	onEditInvoice: PropTypes.func,
	selectedRecords: PropTypes.object,
	updateSelectedRecord: PropTypes.func,
	user: PropTypes.object,
	showMultipleOfficerModal: PropTypes.func,
	hasMoreRecords: PropTypes.bool,
	loadNextPage: PropTypes.func,
	onSendInvoices: PropTypes.func,
	canSendMultipleInvoices: PropTypes.bool,
	clientV4InvoicingDisputesEnabled: PropTypes.bool,
};

export default PendingSubmissionTable;
